import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StaticUrlGeneratorService {
  constructor(private translate: TranslateService) {}

  getStaticUrl(env: string | undefined): string {
    if (!env) {
      return '';
    }
    const staticUrlConfig = this.translate.instant(`staticUrlConfig`);
    return staticUrlConfig[env].assetUrl;
  }

  format(env: string | undefined, urlSegment: string | undefined): string {
    if (!urlSegment) {
      return '';
    }

    if (urlSegment.startsWith(`/assets/cfb`)) {
      return `${this.getStaticUrl(env)}${urlSegment}`;
    }

    return urlSegment;
  }
}
